import React, { useState } from 'react'
import AwsConfig from '../../Config/AwsConfig'
import MovieAutoSuggestionsdata from './movieSearchAutosuggestion'
import { useHistory } from 'react-router-dom'

function AutoSuggestionsmovieID(props) {
  const { pkvalue, pkvalueinput, editRender } = props
  const [AutoSuggestion, setAutoSuggetions] = useState([])
  const [disabled, setdisabled] = useState(true)
  const history = useHistory()
  const poster = url => {
    if (url) {
      const cdnurl = AwsConfig.movieCdnUrl
      if (url && !url.includes(cdnurl)) {
        url = cdnurl + url
        return url
      }

      return url
    }

    return ''
  }

  const editRenderData = () => {
    history.push(`/editmovie?${pkvalue}`)
    editRender()
  }

  const selectInput = suggestion => {
    pkvalueinput(suggestion.PK)
    setAutoSuggetions([])
    setdisabled(false)
  }

  const getSuggestions = async value => {
    pkvalueinput(value)
    try {
      if (value === '') {
        setAutoSuggetions([])
        setdisabled(true)
      } else {
        const input = {
          search: value,
          type: 'movie',
          limit: 100,
          from: 0,
        }
        const autoSuggestions = await MovieAutoSuggestionsdata(input)
        setdisabled(true)
        setAutoSuggetions(
          autoSuggestions && autoSuggestions.movieHits ? autoSuggestions.movieHits : [],
        )
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div style={{ display: 'flex', gap: '10px', margin: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>Movie ID</label>
        <div>
          <input
            type='text'
            className='form-control'
            value={pkvalue ? pkvalue : ''}
            placeholder='please enter pk value'
            onChange={event => getSuggestions(event.target.value)}
            // pkvalueinput(event)
          />
        </div>
        {AutoSuggestion && AutoSuggestion.length >= 1 && (
          <div
            style={{
              border: ' 1px solid gray',
              borderRadius: '6px 6px 6px 6px',
              cursor: 'pointer',
              maxHeight: '500px',
              overflowY: 'scroll',
            }}
          >
            {AutoSuggestion.map((suggestion, index) => (
              <div key={index} onClick={() => selectInput(suggestion)}>
                <ul className='list-group list-group-flush mb-1'>
                  {suggestion.title_En && (
                    <li className='list-group-item'>
                      <div className='media d-flex justify-content-center align-items-center'>
                        <img
                          style={{ width: '2rem', height: '2rem' }}
                          className='rounded-circle mr-3'
                          src={poster(suggestion ? suggestion.posterURL : '')}
                          alt={suggestion.title_En}
                        />
                        <div className='media-body align-self-center'>
                          <label>{suggestion.title_En}</label>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            ))}
          </div>
        )}
        {pkvalue.length <= 0 && <span className='mandatory1'>Movie Id should not be empty</span>}
      </div>
      <div style={{ margin: '20px', position: 'relative', top: '10px' }}>
        <button
          type='button'
          disabled={disabled}
          className='btn btn-primary'
          onClick={() => editRenderData()}
        >
          Edit Movie
        </button>
      </div>
    </div>
  )
}

export default AutoSuggestionsmovieID
